import React from 'react';
import styles from './CustomButton.module.css';

const CustomButton = ({
  children,
  onClick,
  type = 'button',
  disabled = false,
  size = 'medium',
  backgroundImage,
  loading = false,
  className = '',
  ariaLabel,
  ...props
}) => {
  const bgImage = backgroundImage || '/Assets/Images/Common/button-bg-1.svg';

  const buttonClasses = [
    styles.customButton,
    styles[size],
    loading ? styles.loading : '',
    disabled ? styles.disabled : '',
    className
  ].filter(Boolean).join(' ');

  const buttonStyle = {
    backgroundImage: `url(${bgImage})`,
    ...props.style
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={buttonClasses}
      style={buttonStyle}
      aria-label={ariaLabel}
      {...props}
    >
      <div className={styles.buttonContent}>
        {loading ? (
          <svg className={styles.spinner} viewBox="0 0 24 24">
            <circle cx="12" cy="12" r="10" fill="none" strokeWidth="2" strokeDasharray="31.416" strokeDashoffset="31.416">
              <animate attributeName="stroke-dasharray" dur="2s" values="0 31.416;15.708 15.708;0 31.416" repeatCount="indefinite" />
              <animate attributeName="stroke-dashoffset" dur="2s" values="0;-15.708;-31.416" repeatCount="indefinite" />
            </circle>
          </svg>
        ) : (
          children && <p className={styles.buttonText}>{children}</p>
        )}
      </div>
    </button>
  );
};

export default CustomButton;